import React from "react";

const CourtsIcon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.40606 10.6941H5.80762V5.49046C5.80762 3.79742 7.18511 2.41992 8.87815 2.41992H12.5346V3.01836H8.87815C7.5148 3.01836 6.40606 4.12765 6.40606 5.49046V10.6941Z"
        fill="currentColor"
      />
      <path
        d="M6.40606 12.1377H5.80762V19.709H6.40606V12.1377Z"
        fill="currentColor"
      />
      <path
        d="M15.2541 21.496H11.5977V20.8975H15.2541C16.6175 20.8975 17.7262 19.7882 17.7262 18.4254V11.9443H18.3246V18.4254C18.3246 20.1185 16.9471 21.496 15.2541 21.496Z"
        fill="currentColor"
      />
      <path
        d="M18.324 4.20996H17.7256V10.6959H18.324V4.20996Z"
        fill="currentColor"
      />
      <path
        d="M17.1986 13.0015H6.93319L3.30176 10.3945H20.8295L17.198 13.0015H17.1986ZM7.12632 12.4031H17.006L18.9705 10.993H5.16181L7.12632 12.4031Z"
        fill="currentColor"
      />
      <path
        d="M12.2313 12.7031H11.6328V17.5826H12.2313V12.7031Z"
        fill="currentColor"
      />
      <path
        d="M12.2313 5.47266H11.6328V10.6954H12.2313V5.47266Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CourtsIcon;
